export function isNumber(input: string) {
    return !isNaN(parseInt(input, 10)) && input.trim() !== '';
}